import { config } from './../../../config';
import { Injectable } from "@angular/core";

@Injectable()
export class ApiGatewayHelperService {
    spaceId : string = '';
    constructor() { }

    getApiGatewayPrefixUrl(appendSpaceId = false)  {
        let apiGatewayUrl = config.apiGatewayUrl;
        const spaceId = this.getSpaceId();

        if(spaceId && appendSpaceId) {
            apiGatewayUrl += spaceId + '/';
        }
        return apiGatewayUrl;
    }

    setSpaceId (spaceId) : void {
        this.spaceId = spaceId;
    }

    getSpaceId() : string{
        return this.spaceId;
    }
}
